import { InfoIcon, WarningIcon } from "@src/assets";
import { ReactNode } from "react";

interface Props {
  type?: "info" | "warning";
  children: ReactNode;
}
export const Banner = ({ children, type = "warning" }: Props) => {
  return (
    <div
      className={`${
        type === "warning" ? "bg-warning_color/10" : "bg-bg_text_primary/10"
      } rounded-[12px] text-sm text-text_primary text-opacity-60 flex gap-2 items-center p-4 text-left`}
    >
      {type === "warning" ? (
        <WarningIcon className="min-w-5 min-h-5 w-5 h-5" />
      ) : (
        <InfoIcon className="min-w-5 min-h-5 w-5 h-5" />
      )}
      {children}
    </div>
  );
};
